import dasherize from 'underscore.string/dasherize';

angular.module('shared').directive('logIcon', function() {
  return {
    restrict: 'E',
    scope: {
      metaCategory: '=',
      group: '='
    },
    template: `<div class="log-type" ng-class="activityIconClass()"></div>`,
    controller: ["$scope", function($scope) {
      return $scope.activityIconClass = function() {
        var category, group;
        category = dasherize($scope.metaCategory);
        group = `activity--${$scope.group.split('_')[0]}`;
        return [category, group];
      };
    }]
  };
});
